/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Zurück",
      "<h3 class=”header-3”>Status der Barrierefreiheit</h3><p>Der European Accessibility Act verpflichtet uns, unsere E-Commerce-Dienste (einschließlich Identifizierungs- und Zahlungsmethoden) barrierefrei zu gestalten, sodass sie wahrnehmbar, bedienbar, verständlich und robust sind. Darüber hinaus ist es unser Ziel, unsere Websites und mobilen Anwendungen gemäß den <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">W3C Web Content Accessibility Guidelines 2.1, Level AA</a> zu gestalten. Um diese Ziele zu erreichen, haben wir:</p><ul><li>Partnerschaften mit Experten für Barrierefreiheit wie „Level Access“ geschlossen, um unsere Dienste zugänglicher zu machen.</li><li>Unsere digitalen Angebote anhand globaler Standards für Barrierefreiheit bewertet.</li><li>Von einem vielfältigen Team aus Expert:innen gelernt, darunter auch Menschen mit Behinderungen und besonderen Anforderungen an die Barrierefreiheit.</li></ul>",
      "<h3 class=”header-3”>Feedback und Kontakt</h3><p>Obwohl wir bestrebt sind, Barrierefreiheit für alle unsere User zu gewährleisten, kann es dennoch zu gewissen Einschränkungen kommen. Wir freuen uns über dein Feedback, das uns hilft, noch besser zu werden. Solltest du auf Barrieren stoßen oder Informationen in einem alternativen Format benötigen, kontaktiere uns bitte unter accessibility@bumble.com.</p>",
      "<h3 class=”header-3”>Zukünftige Verbesserungen</h3><p>Unsere Arbeit an der Barrierefreiheit ist ein fortlaufender Prozess. Wir werden auch weiterhin:</p><ul>\n<li>Die Barrierefreiheit auf all unseren digitalen Plattformen überwachen und überprüfen.</li>\n<li>Bekannte Probleme beheben und künftige Barrieren verhindern, indem wir Barrierefreiheit von Anfang an in unser Design einplanen.</li><li>Interne Schulungen ausbauen und unser Team weiter sensibilisieren, um inklusives Design noch fester zu verankern.</li></ul>",
      "<h3 class=”header-3”>Zuletzt aktualisiert: November 2025</h3>",
      "<h3 class=”header-3”>Ergriffene Maßnahmen</h3><p>Um die Barrierefreiheit unserer Dienste sicherzustellen, haben wir folgende Maßnahmen ergriffen:</p><ul>\n<li>Wir arbeiten mit „Level Access“ zusammen, um umfassende Bewertungen zur Barrierefreiheit durchzuführen und fachliche Unterstützung zu erhalten.</li>\n<li>Wir haben Tools für die Barrierefreiheit in unsere Plattformen integriert, darunter assistive Technologien wie Tastaturalternativen, Sprachsteuerung und berührungsfreie Navigation.</li>\n<li>Wir führen Usertests mit Menschen mit Behinderungen durch, um direktes Feedback zu erhalten und gezielte Verbesserungen umzusetzen.</li><li>Überlegungen zur Barrierefreiheit wurden fest in unseren Produktentwicklungszyklus und unsere Qualitätssicherungsprozesse integriert.</li><li>Wir haben unternehmensweit ein Programm für digitale Barrierefreiheit etabliert.</li><li>Wir haben eine <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">Plattform für assistive Kundenerlebnisse</a> implementiert. Diese ist kostenlos und steht allen zur Verfügung, die beim Tippen, bei Gesten, der Mausbedienung oder beim Lesen Schwierigkeiten haben. Sie umfasst Tools wie einen Maus- und Tastaturersatz, eine Spracherkennung und -ausgabe sowie eine freihändige/berührungsfreie Navigation.</li></ul>",
      "<h3 class=”header-3”>Unsere Richtlinien</h3><p>Bei Bumble ist Chancengerechtigkeit tief in unseren Werten verwurzelt. Für uns ist das weit mehr als nur ein Trendbegriff – wir arbeiten aktiv daran, das Bumble-Erlebnis barrierefrei, fair und für alle zugänglich zu machen.</p><p>Diese Erklärung zur Barrierefreiheit informiert dich darüber, wie zugänglich unsere Dienste sind und wie wir relevante rechtliche und technische Standards umsetzen. Sie gilt für alle Bereiche unserer Dienste [RS2], die unter den European Accessibility Act fallen – insbesondere für unsere E-Commerce-Dienste, über die du Upgrades für verschiedene Premium-Features von Bumble erwerben kannst. Diese Dienste kannst du direkt über die Bumble-App nutzen.</p>",
      "Erklärung zur Barrierefreiheit (EAA)",
      "Laden im App Store",
      "Jetzt bei Google Play",
      "Karussell",
      "Folie {{number}}",
      "Nächste Folie",
      "Vorherige Folie",
      "Folie",
      "Folie {{number}} von {{total}}",
      "Meine personenbezogenen Daten nicht verkaufen oder weitergeben",
      "Meine personenbezogenen Daten nicht verkaufen oder weitergeben",
      "Sende Compliments auf Bumble, um zu zeigen, dass dir ein Profil gefällt und mach noch vor dem Match auf dich aufmerksam. Probiere es jetzt aus.",
      "Compliments | Wie du Komplimente sendest | Bumble",
      "Deine individuelle Seite mit Leuten, die zu dir passen, täglich aktualisiert.",
      "Entdecken | Finde Leute, die zu dir passen | Bumble",
      "Date in deinem eigenen Tempo und behalte die Kontrolle darüber, wer dein Bumble-Profil sieht, mit dem Inkognito-Modus. Erfahre in unserem Guide, wie du den Inkognito-Modus auf Bumble nutzt.",
      "Inkognito-Modus | Verstecke dein Profil | Bumble",
      "Nachdem ihr euch bei einem IRL-Event von Bumble kennengelernt habt, könnt ihr eure Chemie vertiefen und in der App weiterchatten.",
      "Live Match | Unterhalte dich weiter in der App | Bumble",
      "Brauchst du eine kleine Pause oder etwas Zeit für dich? Dann nutze den Snooze-Modus von Bumble, um dein Bumble-Konto zu pausieren. So datest du ganz nach deinen Regeln.",
      "Snooze-Modus | Pausiere dein Konto | Bumble",
      "Jemanden gesehen, der dir richtig gut gefällt auf Bumble? Zeig mit einem SuperSwipe, dass du es ernst meinst. Tippe auf den Stern im Profil, um dein Like zu betonen, oder erfahre hier mehr Details.",
      "Bumble SuperSwipe | Was ist ein SuperSwipe? | Bumble",
      "Geht's in den Urlaub oder auf Geschäftsreise? Der Reise-Modus auf Bumble hilft dir dabei, an jedem Ort neue, interessante Leute kennenzulernen. Probiere jetzt den Reisemodus aus.",
      "Bumbles Reise-Modus | Date, wo immer du hingehst | Bumble",
      "Willst du wissen, ob eure Connection nicht nur in Nachrichten flowt, sondern auch im echten Leben? Dann teste den Vibe im Videochat oder per Sprachanruf auf Bumble aus.",
      "Videochat | Einfach anrufen | Bumble",
      "Bumble Date",
      "Unsere Apps",
      "Über uns",
      "Karriere",
      "Kontakt",
      "Investieren",
      "Der Shop",
      "Unternehmen",
      "App herunterladen",
      "Barrierefreiheit bei Bumble",
      "Richtlinien",
      "Cookies verwalten",
      "Modern Slavery Act",
      "Hinweis zur Datenerhebung",
      "Datenschutzrichtlinien",
      "AGB",
      "Rechtliches",
      "Washingtons Datenschutzrichtlinie für Gesundheitsdaten von Verbrauchern",
      "QR-Code scannen und Bumble-App holen",
      "Einloggen",
      "Verträge hier kündigen",
      "Jetzt herunterladen",
      "Scanne den QR-Code, um loszulegen.",
      "Finde dein nächstes Date",
      "Hol dir die App",
      "Bumble Startseite",
      "Menü schließen",
      "Menü öffnen",
      "Bald online: Lovestorys von Bumble",
      "Wähle deine Sprache",
      "Sprachauswahl",
      "Fußzeile",
      "Barrierefreiheit bei Bumble",
      "Apple und das Apple logo sind Marken von Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Karriere",
      "Events",
      "Google Play ist eine Marke von Google LLC.",
      "Richtlinien",
      "Investoren",
      "Cookies verwalten",
      "Cookies verwalten",
      "Erklärung zum Modern Slavery Act",
      "Hinweis zur Datenerhebung",
      "Datenschutz",
      "Saisonale Dating-Ratgeber",
      "AGB",
      "Die App",
      "Washingtoner Datenschutzrichtlinie für Gesundheitsdaten von Verbrauchern",
      "Über uns",
      "Ambassadors",
      "Neue Freunde und deinen Tribe finden",
      "Beruflich netzwerken und die Karriere vorantreiben",
      "Eine Beziehung finden, etwas Lockeres oder irgendwas dazwischen",
      "The Buzz",
      "Mehr erfahren",
      "Im Reise-Modus die Welt erkunden",
      "Date",
      "Events",
      "Funktionen",
      "Compliments",
      "Verteile Komplimente, um herauszustechen und zu connecten.",
      "Entdecken",
      "Deine individuelle Seite mit Leuten, die zu dir passen, täglich aktualisiert.",
      "Inkognito-Modus",
      "Nutze Inkognito-Modus, wenn nur Leute dein Profil sehen sollen, die für dich infrage kommen, nicht dein Chef oder deine Verwandten.",
      "Live Match",
      "Bei einem Bumble-Event vor Ort ins Gespräch gekommen? Bleibt danach über die App in Kontakt.",
      "Snooze-Modus",
      "Pause vom Dating? Nutze den Snooze-Modus. Komm einfach zurück, wenn du wieder Lust hast und mach da weiter, wo du warst.",
      "SuperSwipe",
      "Ein Profil, das dir richtig gut gefällt? Zeig, dass es was besonderes ist, mit einem SuperSwipe.",
      "Reise-Modus",
      "Finde deinen Duty-Free-Snack und matche überall auf der Welt, mit dem Reise-Modus.",
      "Video-Chat",
      "Nutze Videochat und Audioanrufe, um den Vibe zu checken, bevor du auf ein Date gehst.",
      "Hol dir die Bumble-App",
      "BFF",
      "Sicherheit",
      "Storys",
      "Support",
      "Der Shop",
      "Hauptmenü",
      "Verteile Komplimente und heb dich von anderen ab.",
      "Compliments",
      "Features, die darauf ausgelegt sind, authentische, respektvolle und tiefgehende Connections zu ermöglichen.",
      "Verstecke dein Profil vor Boss, Family oder Ex-Partnern.",
      "Inkognito-Modus",
      "Pause vom Dating? Nutze den Snooze-Modus.",
      "Snooze-Modus",
      "Gibt’s jemanden, der dir gefällt? Dann zeig es.",
      "SuperSwipe",
      "Date erkunden",
      "Finde deinen Duty-Free-Snack und matche weltweit.",
      "Reise-Modus",
      "Erlebe echte Begegnungen, ohne das Haus zu verlassen.",
      "Video-Anrufe",
      "Erlebe Bumble direkt in deinem Browser.",
      "Web-App",
      "Unsere Leader tragen die Werte von Bumble in ihre Communitys.",
      "Community-Leader",
      "Features, die dir helfen, Gleichgesinnte zu finden und dich über gemeinsame Interessen zu vernetzen.",
      "Organisiere ein Gruppen-Meetup oder entdecke Events in deiner Nähe.",
      "Plans",
      "BFF entdecken",
      "Alle Tipps und Anregungen, die du brauchst, um Liebe und Freundschaft zu entdecken.",
      "Tipps und Geschichten, die dir dabei helfen, die Freundschaften zu finden, die du suchst.",
      "Alles über Freundschaft",
      "Von Tokio bis Toronto – entdecke die Liebe, die weltweit auf Bumble gefunden wird.",
      "Lovestorys",
      "Plane das perfekte Date – egal wann, wo oder mit wem du dich triffst.",
      "Saisonale Dating-Ratgeber",
      "Storys erkunden",
      "Zum Hauptteil springen",
      "Bumble Logo",
      "Navigationsmenü schließen",
      "Navigationsmenü öffnen",
      "Porträt von Whitney Wolfe Herd, Gründerin und CEO von Bumble",
      "Whitney Wolfe Herd gründete Bumble mit der klaren Mission, einen vertrauenswürdigen Ort zu schaffen, an dem Frauen den ersten Schritt machen und Beziehungen auf Respekt basieren.{{__EOL__}}{{__EOL__}}Als CEO verfolgt sie weiterhin dieselbe Vision: Online-Dating soll bewusst, sicher und authentisch sein. Bumble ist mehr als nur Dating – es geht darum, Menschen mit Herz und Engagement dabei zu helfen, das zu finden, was ihnen wirklich wichtig ist. Unsere Technologie und KI nutzen wir gezielt, um zwischenmenschliche Verbindungen zu vertiefen, anstatt sie zu ersetzen. Mit all unseren Erfahrungen – den guten, den unvollkommenen und den ehrlichen – stellen wir sicher, dass sich unsere Community bei Bumble immer willkommen fühlt.",
      "Whitney Wolfe Herd",
      "Ein lächelndes Paar auf dem Rücksitz eines Autos, das sich zum Kuss vorbeugt und Händchen hält, umgeben von Grün.",
      "Wir glauben, dass Liebe in all ihren Formen die Basis für ein glückliches und gesundes Leben ist.",
      "Hallo. Wir sind das Unternehmen der Liebe.",
      "Bumble-Match-Seite mit zwei Profilen und einer Aufforderung, die Unterhaltung zu starten.",
      "Das Ergebnis? Eine Plattform, die sich auf die Bedürfnisse der Mitglieder konzentriert und positive, gesunde Verbindungen schafft.",
      "{{date}} haben wir die Dating-Regeln neu definiert.",
      "Unsere Mission ist es, Menschen zusammenzubringen.",
      "Unser Ziel",
      "Wir stellen die Dating-Regeln auf den Kopf, indem wir Frauen den ersten Schritt machen lassen.",
      "Bumble ist da",
      "{{bff}} wird gestartet, um Menschen zu helfen, ihre Crew zu finden. Denn Liebe kann auch platonisch sein.",
      "Mehr als nur Dating",
      "Serena Williams hilft uns dabei, Frauen, die den ersten Schritt machen, zum Super Bowl zu bringen.",
      "Super-Bowl-Debüt",
      "Wir bringen neue Features raus, um das Dating während der Corona-Pandemie zu erleichtern.",
      "Virtuelles Dating",
      "Wir gehen an die Börse – mit der jüngsten Frau, die diesen Schritt je gewagt hat.",
      "Wir schreiben Geschichte",
      "Zusätzlich zu unserer Anti-Cyberflashing-Technologie stärken wir unsere Richtlinien zum Schutz von Frauen.",
      "Mehr Sicherheit",
      "Wir rücken den Frauensport ins verdiente Rampenlicht.",
      "WNBA x Bumble",
      "Heute gestalten wir eine Zukunft, in der sich Liebe für alle erreichbar anfühlt.",
      "Leadership mit Herz",
      "Alles begann mit einem mutigen Schritt. Heute sind wir der vertrauenswürdigste und effektivste Ort, um die Liebe zu finden.",
      "Scrollen zum Erkunden",
      "Nach links scrollen",
      "Nach rechts scrollen",
      "Unsere Story",
      "Unsere offenen Stellen",
      "Lass uns gemeinsam den sichersten Ort für die Liebe schaffen.",
      "Arbeite mit uns",
      "BFF-App-Seiten mit Fokus auf der Profilansicht und den Interessen-Badges zum Vernetzen mit Freunden",
      "Gerade in eine neue Stadt gezogen oder einfach Lust, deinen Freundeskreis zu erweitern? Mit {{bff}} findest du Leute, die auf deiner Wellenlänge sind.",
      "Leute finden",
      "Eine Bumble-Profil-Collage, die verschiedene Personen mit Ausweisverifizierungs-Badges zeigt, inklusive einer Frau in der Mitte, die ein Selfie vor einem Spiegel macht.",
      "Egal, ob du zum ersten Mal datest oder einen neuen Versuch wagst – Bumble Date hilft dir, sicher und erfüllend zur Liebe zu finden.",
      "Match finden",
      "Lächelnde Frau mit Skateboard in einem Park",
      "Outdoor",
      "Lächelnder Mann joggt in einem Stadtpark",
      "Joggen",
      "Frau hält ein kleines, flauschiges Hündchen im Freien",
      "Habe einen Hund",
      "Bumble herunterladen",
      "Wir wollen, dass unsere Mitglieder echte und erfüllende Beziehungen finden, die ihnen Selbstvertrauen und Freude bringen.",
      "Wir helfen Menschen, ihrer Liebe näherzukommen.",
      "Eine Frau mit langem, dunklem Pferdeschwanz trägt ein schwarzes Oberteil und hat eine Sonnenbrille auf dem Kopf. Sie lächelt, während im Hintergrund das Meer zu sehen ist.",
      "Ein Mann mit Bart, der ein gemustertes Hemd trägt, hält eine Kamera in der Hand. Im Hintergrund sind Bäume und Gebäude zu sehen.",
      "Eine Frau in einer regenbogenfarbenen Jacke trägt silberne Kopfhörer und eine grüne Halskette mit Sternen. Sie schaut direkt in die Kamera.",
      "Schwarzweiß-Porträt eines lächelnden Paares, das sich umarmt",
      "{{name1}} & {{name2}}, verheiratet seit {{num}}",
      "Mehr erfahren",
      "Mehr Storys lesen",
      "\"{{__EOL__}}Wir sind beide von Natur aus Optimisten und packen die Dinge gerne an. Doch zusammen haben wir das Gefühl, als könnten wir Berge versetzen.",
      "Zwei lachende Personen auf einem Tennisplatz; einer hält sich Tennisbälle vor die Augen.",
      "Persönlich treffen",
      "Bei den IRL-Events von Bumble kannst du das Tippen skippen und direkt ins Gespräch kommen. Komm solo oder bring jemanden mit und knüpfe neue Connections.",
      "Beginne das Gespräch offline",
      "Menschen, die es auf Bumble genießen, über Fotos, Video-Chats und Expertentipps Kontakte zu knüpfen.",
      "Anmelden",
      "Werde Teil unseres Member Circles und gestalte die Zukunft von Bumble aktiv mit. In dieser exklusiven Community tauschst du dich direkt mit unserem Team aus – ob in Chats, Diskussionen oder bei Produkttests.{{__EOL__}}{{__EOL__}}Alle Teilnehmenden erhalten vorab Zugang zu neuen Features, exklusive Einblicke in kommende Kampagnen und die Chance, Bumble für alle noch besser zu machen.",
      "Teile deine Ideen",
      "Willst du mehr wissen? Nutze den Video-Chat auf Bumble.",
      "Tippe einfach auf das Video-Symbol in deinem Chat, um einen Videoanruf zu starten, ohne persönliche Kontaktinformationen preiszugeben.",
      "Wie funktioniert der Videochat auf Bumble?",
      "Nein. Bei allen Anrufen und Chats auf Bumble sind deine persönlichen Daten sicher und geschützt. Deine Nummer oder andere Kontaktdaten werden erst dann weitergegeben, wenn du es zulässt.",
      "Kann mein Match meine Telefonnummer sehen?",
      "Auf jeden Fall! Wenn du noch nicht bereit für ein Face-to-face Treffen bist, kannst du dich per Sprachanruf über Audio verbinden. Wähle stattdessen einfach das Anrufsymbol aus.",
      "Kann ich einfach einen Sprachanruf ausprobieren?",
      "Es gibt doch nichts Schöneres als die Benachrichtigung *Neue Nachricht erhalten*. Und klar kann man nur schwer sagen, ob ein Gespräch auch im echten Leben gut flowen wird. Deshalb kommen hier Video- und Sprachanrufe ins Spiel.",
      "Videochat auf Bumble",
      "<a href={{video_chat_url}}>Videochats und Sprachanrufe</a> können euch dabei helfen, einander kennenzulernen und zu entscheiden, ob ihr die Dinge offline nehmen möchtet. Und das Beste daran? Wenn du über Bumble telefonierst, musst du keine Telefonnummern austauschen – so bleiben deine persönlichen Daten sicher, bis du bereit bist, sie zu teilen.",
      "Check die Chemie im Videochat",
      "Schließe die Lücke zwischen Online- und Offline-Dating und entscheide selbst, wann es an der Zeit ist, den Sprung zum Date in real life zu wagen.",
      "Lerne dein Match besser (und schneller) kennen. Ein persönliches Gespräch oder ein Telefongespräch kann viel über jemanden verraten.",
      "Du hast die Kontrolle. Wir werden deine Kontaktdaten vertraulich behandeln, sodass du selbst entscheiden kannst, wann du sie weitergeben möchtest.",
      "Finde heraus, ob du dein Match IRL treffen möchtest",
      "Mach den kurzen Vibe-Check",
      "Connecte ohne Daten preiszugeben",
      "Warum du Video- und Sprachanrufe nutzen solltest",
      "Bist du bereit für ein Gespräch? Du kannst direkt in deinem Chat in der Bumble-App wählen, ob du einen Sprach- oder Videoanruf starten möchtest. Um einen Videoanruf zu starten, tippe auf das graue Videokamera-Symbol in der oberen rechten Ecke. Neben dem Symbol werden auch drei Punkte angezeigt. Klicke darauf, um die Option für einen Sprachanruf anzuzeigen.",
      "Wie funktioniert der Videochat?",
      "Bereit, Compliments auszuprobieren?",
      "Wenn du jemandem ein Compliment sendest, sieht die Person es, sobald du in ihrem Feed auftauchst.",
      "Was passiert, wenn du jemandem auf Bumble ein Kompliment sendest?",
      "Wenn dir das Kompliment der Person gefällt, dann matche mit ihr. Du siehst das Kompliment in deinem Chat und es gelten die üblichen Regeln von <a href={{make_the_first_move_url}}>Mach den ersten Schritt</a>.",
      "Wie antworte ich auf ein Kompliment?",
      "Du kannst {{num}} [[Compliments:num]] kostenlos versenden. Wenn du alle aufgebraucht hast, kannst du in der App Bumble weitere Komplimente in Paketen von bis zu 30 Stück kaufen. Eines davon wird zum Versenden des Kompliments verwendet (hebe den Rest für den Fall auf, dass dir ein anderes Profil gefällt). Keine Sorge, sie verfallen nicht!",
      "Wie viele Komplimente kann ich senden?",
      "Ein nettes Wort (oder zwei) kann viel bewirken. Wenn du ein Kompliment machen möchtest, aber keine Ahnung hast, wie du anfangen sollst, dann lass dich von diesen Ideen inspirieren:",
      "Mehr Beispiele ansehen",
      "„Wer [Künstlername] mag, hat einen guten Geschmack.”",
      "„Dein Lachen wirkt ansteckend“",
      "„Deine Bio hat mich echt zum Lachen gebracht. Punkt für dich.“",
      "So sendest du bessere Komplimente auf Bumble",
      "Willst du jemanden happy machen? Klingt, als sei es Zeit für Compliments™.",
      "Compliments™ auf Bumble",
      "Nutze Compliments auf Bumble, um einem potenziellen Match mitzuteilen, dass dir das Profil gefällt (und die Person happy zu machen!). Du bekommst Compliments als Teil deiner {{service_level_lexeme_name}} Mitgliedschaft. Sie sind auch ein Weg, Nachrichten zu senden und zu empfangen, bevor du überhaupt ein Match hast.",
      "Wie Compliments funktioniert",
      "Wenn du ein Kompliment bekommst, wird es im Profil des Absenders angezeigt. Du erhältst außerdem eine Benachrichtigung, dass jemandem ein Teil deines Profils gefällt.",
      "Deine Komplimente ansehen",
      "Du kannst ein Compliment senden, indem du auf das gelbe Herzsymbol unten im Profil einer Person tippst. Es ist wichtig, wo du tippst, denn du machst diesem bestimmten Foto oder Teil des Profils ein Kompliment! Wenn du klickst, öffnet sich ein Textfeld, in das du deine Nachricht schreiben kannst (maximal 150 Zeichen).",
      "Sende ein Kompliment",
      "JETZT Bumble HERUNTERLADEN UND ENTDECKEN",
      "Jeden Tag ab 9 Uhr sieht du in „Entdecken“ neue Leute. Du kannst mit ihnen über Dinge connecten, die ihr gemeinsam habt.",
      "Wann wird die „Entdecken“-Seite aktualisiert?",
      "Im Bereich „Entdecken“ werden deine potenziellen Matches in drei Kategorien sortiert: ähnliche Interessen, gleiche Datingziele und gemeinsame Communitys. Wir empfehlen dir auch Profile basierend auf deinen vorherigen Matches.",
      "Wie wird meine „Entdecken“-Seite zusammengestellt?",
      "Deine individuelle Seite mit Leuten, die zu dir passen, täglich aktualisiert.",
      "FINDE LEUTE, DIE DEINEN VIBE MATCHEN MIT {{qr_code}} ENTDECKEN",
      "Unter „Entdecken“ schlagen wir dir eine Auswahl an Leuten mit ähnlichen Interessen, Datingzielen und Communitys vor. Vielleicht passt es ja.",
      "Jetzt Entdecken",
      "SUCHST DU NEUE WEGE,\nGEMEINSAMKEITEN ZU ENTDECKEN?",
      "Die „Entdecken“-Seite wird täglich aktualisiert, um dir noch mehr passende Leute anzuzeigen. So verbringst du weniger Zeit damit, nach Matches zu suchen und hast mehr Zeit, die Leute richtig kennenzulernen, mit denen du vibst.",
      "TÄGLICH NEUE EMPFEHLUNGEN",
      "Die Empfehlungen in „Entdecken“ basieren auf deinem Profil und Leuten, mit denen du früher gematcht hast. Du siehst also Leute, die mögen, was du magst und dasselbe wollen wie du – ob das veganes Schnitzel oder eine feste Beziehung ist.",
      "PASSGENAU{{__EOL__}}FÜR DICH",
      "Bumble herunterladen",
      "Häufig gestellte Fragen",
      "Bumble inkognito durchstöbern?",
      "Wenn du den Inkognito-Modus aktivierst, wirst du anderen Mitgliedern von Bumble nicht angezeigt, es sei denn, du likst deren Profil.",
      "Wie funktioniert der Inkognito-Modus?",
      "Ohne den Inkognito-Modus ist dein Profil für andere Mitglieder von Bumble sichtbar, wenn du ihren Präferenzen, wie Alter und Wohnort, entsprichst. Wenn du den Inkognito-Modus aktivierst, können andere Personen dich erst dann sehen, wenn du sie gelikt hast.",
      "Wer kann mich im Incognito-Modus von Bumble sehen?",
      "Der Inkognito-Modus ist nicht dasselbe wie <a href={{blocking_on_bumble_url}}>jemanden auf Bumble zu blockieren</a>. Mit dieser Funktion können nur Leute dein Profil sehen, denen du schon ein Like gegeben hast (oder denen du schon eine Nachricht gesendet hast).",
      "Ist der Inkognito-Modus dasselbe wie jemanden blockieren?",
      "Kontrolliere selbst, wer dein Profil sieht, mit dem Bumble Inkognito-Modus",
      "Inkognito-Modus auf Bumble",
      "Wenn du eine Auszeit vom Dating oder Browsen bei Bumble nehmen möchtest, ohne dass andere User dein Profil sehen können, kannst du den Inkognito-Modus aktivieren. Dann bist du für alle unsichtbar – es sei denn, du likst jemanden. So kannst du steuern, was du teilst und wer dich sieht.",
      "Profil verbergen im Inkognito-Modus",
      "Du entscheidest, wer deine Fotos und persönlichen Infos sehen kann.",
      "Möchtest du etwas Persönliches in dein Profil schreiben? Du kannst diskret mit deinen aktuellen Matches teilen, was du möchtest.",
      "Stöbere frei herum, ohne dir Sorgen zu machen, dass du einem Ex begegnest, den Arbeitskollegen oder jemand anderem, der nicht auf deinem Dating-Radar ist.",
      "Du hast die volle Kontrolle",
      "Welche Infos willst du teilen?",
      "Peinliche Momente vermeiden",
      "Warum du den Inkognito-Modus lieben wirst",
      "Der Inkognito-Modus ist nur für {{service_level_lexeme_name}} und {{service_level_lexeme_name_two}} Mitglieder. Sobald du dich angemeldet hast, kannst du den Inkognito-Modus aktivieren, indem du den Bereich „Profil“ öffnest, oben rechts auf „Einstellungen“ tippst und den Schieberegler aktivierst.",
      "Gönn dir {{service_level_lexeme_name}}",
      "Wie du den Inkognito-Modus auf Bumble nutzt",
      "LADE JETZT Bumble HERUNTER UND TESTE LIVE MATCH",
      "Öffne die Bumble-App und drücke am unteren Bildschirmrand auf dein Profilsymbol. Danach findest du das QR-Code-Symbol oben rechts im Bildschirm. Drücke darauf, um es zu öffnen.",
      "Wo finde ich meinen persönlichen QR-Code?",
      "Nein. Damit es funktioniert, musst du mit dem Internet verbunden sein und den aktuellen QR-Code für Live Match abrufen.",
      "Kann ich meinen QR-Code als Screenshot teilen?",
      "Nein! Wenn eine Person den Code scannt, werdet ihr automatisch als Match connected.",
      "Müssen beide Personen den QR-Code scannen?",
      "Mit Live Match siehst du automatisch, was du und dein neues Match gemeinsam habt – so bekommst du von Anfang an einen Eindruck davon, ob ihr zusammenpasst.",
      "SCHNELLER GEMEINSAMKEITEN FINDEN",
      "Bei einem Bumble-Event vor Ort ins Gespräch gekommen? Bleibt danach über die App in Kontakt.",
      "VON DER LIVE BEGEGNUNG ZUM {{qr_code}} LIVE MATCH",
      "Mit Live Match kannst du ganz einfach aus einer netten Begegnung ein „wir bleiben in Kontakt“ machen, ohne Nummern oder Social-Media-Profile auszutauschen. Lass einfach deinen QR-Code scannen, um sofort auf Bumble zu matchen.",
      "Nutze Live Match",
      "LERNE JEMANDEN BEI EINEM Bumble LIVE EVENT KENNEN!",
      "Statt Social-Media-Profile oder Nummern auszutauschen, kannst du mit Live Match zuerst in der App euren Vibe checken. So könnt ihr euch sicher besser kennenlernen, mit den Sicherheitsfunktionen von Bumble.",
      "EINFACH SICHERER CONNECTEN",
      "Nachdem ihr euch bei einem Bumble-Event vor Ort kennengelernt habt, könnt ihr euch in der App weiter über eure gemeinsamen Interessen unterhalten. Ob Kaffee-Lovers oder Fans von seltenen Sukkulenten, es wird definitiv spannend.",
      "HALTE DAS GESPRÄCH AM LAUFEN",
      "Brauchst du eine Pause? Probier mal den Snooze-Modus.",
      "Ja, du kannst jederzeit deine Einstellungen oder deinen Feed aufrufen und Snooze ausschalten.",
      "Kann ich den Snooze-Modus früher beenden?",
      "Öffne die Einstellungen, tippe auf Snooze und wähle aus, wie lange du weg sein möchtest. Komme zurück, wann immer du dich bereit fühlst.",
      "Wie verwende ich den Snooze-Modus im Profil?",
      "Nein – während du dich im Snooze-Modus befindest, werden alle Swipe-and-Chat-Aktivitäten unterbrochen. Wenn du den Feed für neue Leute öffnest, siehst du eine Nachricht, die sagt, wie lange der Snooze-Modus noch läuft, und dir anbietet, ihn zu beenden.",
      "Kann ich im Snooze-Modus noch Profile sehen und chatten?",
      "Leute, denen du schon eine Nachricht gesendet hast, sehen deinen Abwesenheitsstatus (sofern du einen festgelegt hast). Andernfalls sehen sie deine vorherigen Nachrichten wie gewohnt in ihrem Posteingang.",
      "Was sehen aktuelle Matches, wenn ich im Snooze-Modus bin?",
      "Du hast die volle Kontrolle über deine Aktivität bei Bumble und kannst dir jederzeit eine Auszeit von der Plattform nehmen.",
      "Du kannst bestehende Matches mit einem Status-Update auf dem Laufenden halten, damit es nicht so aussieht, als hättest du sie <a href={{ghosted_article_url}}>geghostet</a>. Außerdem ist alles automatisiert – du musst also keine Nachrichten senden.",
      "Mach ruhig mal Pause vom aktivem Dating, ohne deine Connections oder Chats zu verlieren.",
      "Date nach deinen Regeln",
      "Sag deinen Connections Bescheid",
      "Mach 'ne Pause, aber nicht von deinen Matches",
      "Warum wir den Snooze-Modus lieben",
      "Öffne die Bumble-App, öffne den Profil-Reiter und tippe auf das Einstellungssymbol in der oberen rechten Ecke. In deinen Einstellungen tippst du auf Snooze und wählst aus, wie lange du weg sein wirst. Du kannst dein Profil für 24 Stunden, 72 Stunden, eine Woche oder unbegrenzt ausblenden.{{__EOL__}}{{__EOL__}}Denk daran, dass Matches ohne aktive Chats ablaufen, während du im Snooze-Modus bist. Wenn du einen Abwesenheitsstatus einstellst, können die Personen, mit denen du gerade chattest, sehen, dass du abwesend bist.",
      "Wie der Snooze-Modus auf Bumble funktioniert",
      "Wenn das Leben hektisch wird, kann der Snooze-Modus helfen. Pausiere dein Bumble-Konto und date nach deinen Regeln.",
      "Snooze-Modus auf Bumble",
      "Der Snooze-Modus ist eine einfache Möglichkeit, dein Konto zu pausieren, wenn du eine Auszeit vom Dating nehmen willst. Du kannst weiterhin mit deinen bestehenden Matches chatten, dein Profil wird nur für andere Leute ausgeblendet, bis du wieder bereit dafür bist. Durch Einschalten des Snooze-Modus verlierst du weder deine Profildetails noch löschst du bestehende Kontakte.",
      "Snooze dein Bumble-Profil",
      "Während du im Snooze-Modus bist, kannst du bestehende Matches über ein Status-Update wissen lassen, dass du eine Auszeit nimmst. Wähle die passende Botschaft aus: „Ich bin auf Reisen“, „Arbeit geht zurzeit vor“, „Ich mache Digital Detox“ oder „Ich brauche Zeit für mich“. Was auch immer grade los ist, wir haben das Richtige für dich.",
      "Setz dich auf abwesend",
      "Wenn du den Snooze-Modus aktivierst, wird dein Konto bei Bumble (bzw. {{page_partner_name_bff}}) pausiert. Deine Matches erfahren von deinem Snooze-Modus nur, wenn du es ihnen mitteilst. Wenn du früher als geplant den Snooze-Modus beenden möchtest, geh einfach zurück in die Einstellungen und tippe auf „Snooze-Modus deaktivieren“. So einfach ist das.",
      "Pausiere deine Chats",
      "Nutze SuperSwipe auf Bumble",
      "So viele du willst! {{service_level_lexeme_name}} Benutzer erhalten jede Woche {{num}} [[superswipe:num]], aber du kannst deinen Vorrat jederzeit auffüllen. Mitglieder mit dem kostenlosen Basistarif können SuperSwipe-Pakete kaufen.",
      "Wie viele SuperSwipes kann ich auf Bumble senden?",
      "Wenn jemand deinem Profil einen Super-Swipe gibt, wirst du sofort benachrichtigt. Im Profil der Person siehst du außerdem eine besondere Markierung, die zeigt, dass sie dich gelikt hat.",
      "Wie erfahre ich, ob ich ein SuperSwipe bekommen habe?",
      "Ernsthaft Interesse? Es gibt eine coole Art, das Eis zu brechen. Sende einfach einen SuperSwipe, um zu zeigen, dass du an jemandem interessiert bist, und komm schneller ins Gespräch.",
      "SuperSwipe auf Bumble",
      "Sich von der Masse abzuheben, ist nicht immer einfach, aber SuperSwipe kann dir dabei helfen, einen guten ersten Move zu machen.{{__EOL__}}{{__EOL__}}Wenn du statt dem regulären Rechts-Swipe ein SuperSwipe verwendest, wird der Person eine Benachrichtigung über dein Like geschickt. Du wirst dann ganz vorne im Feed dieser Person gezeigt mit einer besonderen Markierung. Wenn der andere dir auch ein Like gibt, könnt ihr direkt miteinander chatten.",
      "Was ist ein SuperSwipe?",
      "Mut zu zeigen und aufzufallen",
      "Mehr Chats zu starten",
      "Mehr Connections zu finden",
      "SuperSwipe kann dir helfen…",
      "Wenn du <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> oder Bumble {{service_level_lexeme_name_one}} hast, erhältst du {{num}} [[superswipe:num]] kostenlos pro Woche. Außerdem können alle Mitglieder im Reiter „Profil“ Pakete mit bis zu {{num_two}} [[superswipe:num_two]] kaufen. Wenn du {{service_level_lexeme_name_three}} hast, erhältst du {{num_three}} [[superswipe:num_three]] pro Woche.{{__EOL__}}{{__EOL__}}SuperSwipen ist ganz einfach: Wenn dir jemand gefällt, tippe unten in deren Profil einfach auf das gelbe Sternsymbol.",
      "So funktionieren SuperSwipes",
      "Date wo immer du gerade bist, mit Bumbles Reise-Modus",
      "<a href={{bumble_premium_url}}>{{service_level_lexeme_name}}-Mitglieder</a> können den Reise-Modus nutzen. Wenn du ihn einschaltest, siehst du in deinem Feed neue Gesichter aus einer Stadt deiner Wahl.",
      "Wie nutze ich den Reise-Modus?",
      "So ziemlich – wir haben ein paar Sicherheitsbeschränkungen, die sich im Laufe der Zeit ändern können, aber der Reise-Modus ist für die meisten Ziele verfügbar.",
      "Kann ich den Reise-Modus überall nutzen?",
      "Im Reise-Modus wird dein Standort als Zentrum deiner ausgewählten Stadt angezeigt, sodass neue Kontakte in der Umgebung dich finden können. Sie sehen in deinem Profil einen Hinweis, dass du dich im Reise-Modus befindest, sodass sie wissen, dass du zu Besuch bist oder einen Besuch planst.",
      "Packst du deine Koffer für den Urlaub oder ziehst in eine neue Stadt? Aktiviere den Reise-Modus von Bumble und date auch, wenn du unterwegs bist.",
      "Reise-Modus auf Bumble",
      "Der Reise-Modus ist das ultimative Tool, um unterwegs Leute kennenzulernen. Wähle einen beliebigen Ort auf der Welt aus, wo dein Profil angezeigt werden soll. So kannst du überall dort daten, wo dich deine Abenteuer hinführen.",
      "Was ist der Reise-Modus?",
      "Niemand kennt einen Ort besser als die Locals. Der Reise-Mode kann dir dabei helfen, mit den Leuten in Kontakt zu treten, die deine Reise zu etwas ganz Besonderem machen können.",
      "Ändere deinen Standort bis zu sieben Tage vor deiner Abreise in die Stadt deines Aufenthalts, damit du Dates und Treffen im Voraus planen kannst.",
      "Denke über Strandurlaub hinaus – vielleicht bist du über die Feiertage zu Hause, auf Geschäftsreise oder erkundest eine neue Stadt. Finde Romantik, wo auch immer du landest.",
      "Finde die besten Orte für ein Date in deiner Nähe",
      "Ein Abenteuer erleben",
      "Finde echte Kontakte",
      "Gründe, den Reise-Modus zu lieben",
      "Den Reise-Modus können Mitglieder von <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} und {{service_level_lexeme_name_two}}</a> auf Bumble nutzen. Tippe oben rechts in deinem Profil auf das Zahnrad für Einstellungen und scrolle runter, bis du den Reise-Modus siehst. Wähle dann einen neuen Standort aus, um die Leute vor Ort zu sehen. In deinem Profil wird für potenzielle Matches angezeigt, dass du dich im Reise-Modus befindest.",
      "Wie funktioniert der Reise-Modus?",
      "Ausprobieren",
      "Hier gilt: Kindness ist sexy, du bist perfekt, wie du bist, und Frauen kommen zuerst. Immer.",
      "Das Zuhause von Mach den ersten Schritt™",
      "Gesunde Beziehungen sind wichtig für ein glückliches Leben. Bumble ist dafür gemacht, dass du genau solche Beziehungen findest - egal, ob du Herzklopfen suchst, neue Freunde finden oder beruflich networken willst.",
      "Warum Bumble wichtig ist",
      "Wir setzen uns für Integrität, Kindness, Gleichberechtigung, Vertrauen und Respekt in jeder Phase einer Beziehung ein. Wir unterstützen nicht nur jede Orientierung, wir feiern sie - egal, ob du hier die große Liebe finden oder einfach nur Spaß haben willst.",
      "Was Bumble wertschätzt",
      "Auf Bumble bestimmen Frauen, was sie wollen, indem sie selbst den ersten Schritt machen oder einen Opening Move vorgeben, auf den alle Matches antworten können. Das verändert die altmodische Machtdynamik und fördert die Gleichberechtigung von Anfang an.",
      "Wie Bumble funktioniert",
      "Über uns",
      "Jetzt herunterladen",
      "Die App ist sogar noch besser.",
      "Features, die Online-Dating einfach viel angenehmer machen",
      "12. Februar 2024",
      "Wie du emotionale Intimität in deiner Beziehung förderst",
      "25. Jan. 2024",
      "Wie du Bumble nutzt, wenn du noch nie eine Dating-App benutzt hast",
      "5. Februar 2024",
      "Deception Detector™",
      "Druckreife Dating-News",
      "Pause vom Dating? Nutze den <b>Snooze-Modus</b>. Komm einfach zurück, wenn du wieder Lust hast und mach da weiter, wo du warst.",
      "Mach eine Pause",
      "Lern dein Match besser kennen, bevor du IRL auf ein Date gehst. Nutze <b>Videoanrufe</b> und <b>Sprachnachrichten</b>.",
      "Hör dir den Vibe an",
      "Mehr anzeigen",
      "Leg deinen <b>Opening Move</b> fest und gib deinem Match ein Gesprächsthema vor, um den Chat zu starten.",
      "Mehr Chats, ohne Stress",
      "Finde deinen Duty-Free-Snack und matche überall auf der Welt, mit dem <b>Reise-Modus</b>.",
      "Nimm uns mit",
      "Ein Profil, das dir richtig gut gefällt? Zeig, dass es was besonderes ist, mit einem <b>SuperSwipe</b>.",
      "Einfach auffallen",
      "Wenn dir was gefällt in einem Profil, schick ein <b>Kompliment</b> und connecte, um herauszustechen.",
      "Mach jemanden happy",
      "Nutze <b>Inkognito-Modus</b>, wenn nur Leute dein Profil sehen sollen, die für dich infrage kommen, nicht dein Chef oder deine Verwandten.",
      "Geh undercover",
      "Date nach deinen Regeln",
      "Ein paar Monate später traf sie dort auch eine ihrer Brautjungfern",
      "Hannah lernte ihren jetzigen Ehemann auf Bumble kennen.",
      "Bevor sie zusammen ihr Tiny-House bauten, lernten sich Carène und You-Liang auf Bumble kennen, wo You-Liang von Carènes Reisefotos fasziniert war.",
      "Carène und You-Liang",
      "Brian und Kaci waren zusammen im Ausland stationiert - aber sie haben sich auf Bumble kennengelernt",
      "Brian und Kaci",
      "Wenn es für sie funktioniert hat, könnte es auch für dich funktionieren.",
      "Mach den nächsten Move",
      "Neues entdecken",
      "Du hast was Besseres verdient, deshalb haben wir für dich tolle neue Möglichkeiten geschaffen, mit denen du mehr Dates findest und zwar ohne den ganzen Stress.",
      "Leg die Messlatte wieder höher, wo sie hingehört",
      "Über Bumble",
      "Bumble ist die einzige App, die Dating besser macht, denn hier steht das Erlebnis von Frauen im Vordergrund. Wenn etwas besser ist für Frauen, dann ist es besser für alle.",
      "Make the first move™",
      "Finde jemanden, den du so richtig gerne daten willst, und dann mach den ersten Schritt. Geh in die Connection, bonde über Dinge, die ihr beide liebt, und vor allem: habt Spaß dabei.",
      "Lern jemanden kennen mit Bumble Date",
      "Finde Freunde mit Work-Benefits. Connecte mit anderen Professionals, um deinen nächsten Job, einen Mentor oder sogar eine neue Karriere zu finden.",
      "Mach Boss-Moves mit Bumble Bizz",
      "Lerne Leute kennen, die so sind wie du. Oder anders. Finde neue Freunde und entdecke Dinge, die ihr zusammen unternehmen könnt - ob zu Hause oder unterwegs.",
      "Finde neue Freunde auf Bumble For Friends",
      "So viel mehr als Dating",
      "Bumble ist die Dating-App, bei der Frauen den ersten Schritt machen. Die App, die revolutioniert hat, wie wir heute daten, gesunde Beziehungen aufbauen und networken. Jetzt herunterladen.",
      "Bumble auf {{social_network}}",
      "Mehr erfahren",
      "Lade dir die Bumble-App aus dem App Store oder bei Google Play herunter und melde dich mit demselben Account an, den du auch bei Bumble Web genutzt hast.{{__EOL__}}{{__EOL__}}Scanne einfach den QR-Code unten mit deinem Smartphone oder Tablet, um direkt loszulegen.{{__EOL__}}{{__EOL__}}Deine Matches und Chats warten schon in der App auf dich. 💛",
      "Hol dir die App",
      "Damit wir dir weiterhin die beste Experience und die stärksten Sicherheits-Features bieten können, gibt es Bumble jetzt nur noch als App.",
      "Bumble gibt’s jetzt nur noch als App.",
      "Verpasse keine Begegnung",
      "Telefoniere, ohne deine Nummer preiszugeben",
      "Geh auf Nummer sicher bei deinen Matches",
      "Aktiviere Echtzeit-Benachrichtigungen, um keine Nachricht zu verpassen.",
      "Nutze Video- und Sprachanrufe direkt in der App, um sicher vom Match zum echten Treffen überzugehen.",
      "Chatte unbesorgt mit verifizierten Mitgliedern dank der einfachen Foto- und Ausweisverifizierung direkt in der App.",
      "Warum zur Bumble-App wechseln?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "Wir konnten die gesuchte Seite leider nicht finden.",
      "Kontakt",
      "Sorry, da ist was schiefgegangen!",
      "(opens in new window)",
      "FAQ",
      "Cookie Policy",
      "Premium",
      "Bumble – Blog",
      "Karriere",
      "Chat",
      "Städte",
      "Cookies verwalten",
      "Copyright © 2006 bis heute. Bumble. Alle Rechte vorbehalten.",
      "Bericht: Zuversicht beim Dating",
      "Apple und das Apple logo sind Marken von Apple Inc.{{__EOL__}}Google Play ist eine Marke von Google LLC.",
      "Jetzt downloaden",
      "Facebook",
      "Wir sind auch hier:",
      "Hilfebereich",
      "Instagram",
      "Sprache",
      "LinkedIn",
      "Bumble ist Teil von Bumble Inc.",
      "Datenschutzrichtlinien",
      "Safety Centre",
      "Sitemap",
      "Erklärung zum Modern Slavery Act",
      "AGB",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "Komplimente",
                  "Komplimente",
                  "Komplimenten",
                  "Komplimente"
            ],
            "singular": [
                  "Kompliment",
                  "Kompliments",
                  "Kompliment",
                  "Kompliment"
            ]
      },
      "day": {
            "plural": [
                  "Tage",
                  "Tage",
                  "Tagen",
                  "Tage"
            ],
            "singular": [
                  "Tag",
                  "Tages",
                  "Tag",
                  "Tag"
            ]
      },
      "hour": {
            "plural": [
                  "Stunden",
                  "Stunden",
                  "Stunden",
                  "Stunden"
            ],
            "singular": [
                  "Stunde",
                  "Stunde",
                  "Stunde",
                  "Stunde"
            ]
      },
      "minute": {
            "plural": [
                  "Minuten",
                  "Minuten",
                  "Minuten",
                  "Minuten"
            ],
            "singular": [
                  "Minute",
                  "Minute",
                  "Minute",
                  "Minute"
            ]
      },
      "month": {
            "plural": [
                  "Monate",
                  "Monate",
                  "Monaten",
                  "Monate"
            ],
            "singular": [
                  "Monat",
                  "Monats",
                  "Monat",
                  "Monat"
            ]
      },
      "second": {
            "plural": [
                  "Sekunden",
                  "Sekunden",
                  "Sekunden",
                  "Sekunden"
            ],
            "singular": [
                  "Sekunde",
                  "Sekunde",
                  "Sekunde",
                  "Sekunde"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes",
                  "SuperSwipes",
                  "SuperSwipes",
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe",
                  "SuperSwipes",
                  "SuperSwipe",
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "Jahre",
                  "Jahre",
                  "Jahren",
                  "Jahre"
            ],
            "singular": [
                  "Jahr",
                  "Jahres",
                  "Jahr",
                  "Jahr"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
